import ProductDescription from './ProductDescription'

const FrozenVegsFruitsProduct = {
  ...ProductDescription,
  category: '19',
  subCategory: '002',
  IsBroadband: true,
  ItemType: '',
  Size: '',
  PackageType: '',
  FrozenPackageCertification: false,
  OrganicVerification: false,
  FrozenProductType: 'Fruit',
  otherType: '',
  otherPackageType: '',
}

export default FrozenVegsFruitsProduct
